module.exports = __webpack_public_path__ + "img/14f.3a15b886.png";